export default function (path) {
  this.showTips = false;
  let user = localStorage.getItem('user');
  // console.log(uid);
  if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
    window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
  }
  let origin = window.location.origin;
  if (user) {
//          http://localhost:8080/#/sign/add/0    报名信息页面
    let port = location.port;
    window.open(origin + '/tpl/sign/add/0', '', '');
    return;
  }
  const back = encodeURIComponent(location.href);
  let url = origin+`/login?back=${back}&cid=${this.$route.params.cid}`
  window.location.href = url
}



// WEBPACK FOOTER //
// ./src/commen/loginlogic.js